import React from 'react';
import { useLocation } from 'react-router-dom';
import StandardQrForm from './StandardQrForm';
import GroceryQrForm from './GroceryQrForm';

const QrForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const vendorId = queryParams.get('vendorId') || '';
  const businessType = (queryParams.get('businessType') || '').toLowerCase().trim();
  const groceryMode = (queryParams.get('groceryMode') || queryParams.get('mode') || 'retail')
    .toLowerCase()
    .trim();
  const tableNumber = queryParams.get('table') || '';

  if (!vendorId) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Invalid QR</h2>
        <p>vendorId missing hai.</p>
      </div>
    );
  }

  if (businessType === 'grocery') {
    return (
      <GroceryQrForm
        vendorId={vendorId}
        groceryMode={groceryMode}
        tableNumber={tableNumber}
      />
    );
  }

  return <StandardQrForm />;
};

export default QrForm;
